import { FETCH_VOICES_SUCCESS, SET_DRILLDOWN_LEVEL, SET_USER_ACTIVE_IN_EDITOR, SET_IS_CURSOR_AT_START, SET_FULLSCREEN } from '.'

const fetchVoicesSuccessAction = (payload) => {
  return {
    type: FETCH_VOICES_SUCCESS,
    payload
  }
}

const setDrilldownLevel = (payload) => {
  return {
    type: SET_DRILLDOWN_LEVEL,
    payload
  }
}

const setUserActiveInEditor = (payload) => {
  return {
    type: SET_USER_ACTIVE_IN_EDITOR,
    payload
  }
}

const setIsCursorAtStart = (payload) => {
  return {
    type: SET_IS_CURSOR_AT_START,
    payload
  }
}

const setFullscreen = (payload) => {
  return {
    type: SET_FULLSCREEN,
    payload
  }
}

export { fetchVoicesSuccessAction, setDrilldownLevel, setUserActiveInEditor, setIsCursorAtStart, setFullscreen }
